/**
 * Integer or up to 2 decimal places (aligned with Add more time → Revised estimate).
 */
export const HOURS_DECIMAL_PATTERN = /^[0-9]+(\.[0-9]{1,2})?$/;

export const HOURS_DECIMAL_PATTERN_MESSAGE =
  "Hours must be a valid number (up to 2 decimal places)";

/** Strips invalid chars; keeps one `.` and at most 2 digits after it. */
export function sanitizeDecimalHoursInput(e: {
  target: HTMLInputElement;
}): void {
  const input = e.target;
  let v = input.value.replace(/[^0-9.]/g, "");
  const dot = v.indexOf(".");
  if (dot !== -1) {
    v = v.slice(0, dot + 1) + v.slice(dot + 1).replace(/\./g, "");
    const [whole, frac] = v.split(".");
    if (frac !== undefined && frac.length > 2) {
      v = `${whole}.${frac.slice(0, 2)}`;
    }
  }
  input.value = v;
}
